import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { CustomDialogService } from "../../../../services/customdialog.service";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import {
    EnergyConsumptionReportConfiguration,
    EnergyConsumptionReportConfigurationService
} from "../../../../services/energy-consumption-report-configuration.service";
import { EnergyConsumptionReportConfigurationFormComponent } from "./energy-consumption-report-configuration-form.component";

@Component({
    selector: "energy-consumption-report-configuration-list",
    templateUrl: "./energy-consumption-report-configuration-list.component.html",
    styleUrls: ["../transmissionmode/defaulttransmissionmode-list.component.less"],
    standalone: false
})
export class EnergyConsumptionReportConfigurationListComponent implements OnInit, OnDestroy {
    columnsToDisplay = ["ItemNo", "ControllerType", "Enable", "SendInterval", "ReportingInterval", "actions"];
    list: EnergyConsumptionReportConfiguration[] = [];
    dataSource = new MatTableDataSource<EnergyConsumptionReportConfiguration>();
    private subscriptionControllerType: any;

    constructor(
        private readonly configurationService: EnergyConsumptionReportConfigurationService,
        private readonly defaults: DefaultValuesService,
        private readonly dialog: MatDialog,
        private readonly customDialog: CustomDialogService
    ) { }

    ngOnInit(): void {
        this.subscriptionControllerType = this.defaults.controllerTypeMessageChanges$.subscribe(() => this.refresh());
        this.refresh();
    }

    ngOnDestroy(): void {
        this.subscriptionControllerType?.unsubscribe();
    }

    btnNew(): void {
        this.openForm({ controllerType: "", enable: false, sendInterval: "", reportingInterval: 15 });
    }

    onRowEdit(element: EnergyConsumptionReportConfiguration): void {
        this.openForm(element);
    }

    btnRefresh(): void {
        this.refresh();
    }

    onDelete(element: EnergyConsumptionReportConfiguration): void {
        this.customDialog.openConfirm({
            title: "DELETE ENERGY CONSUMPTION REPORT CONFIGURATION",
            message: `Configuration for controller type "${element.controllerType}" will be deleted. Continue?`,
            caller: this
        });

        this.customDialog.confirmed().subscribe(result => {
            if (result.confirmed) {
                this.configurationService.delete(element).subscribe({ next: () => this.refresh(), error: () => { } });
            }
        });
    }

    private openForm(configuration: EnergyConsumptionReportConfiguration): void {
        const dialogRef = this.dialog.open(EnergyConsumptionReportConfigurationFormComponent, {
            panelClass: "custom-mat-dialog",
            disableClose: false,
            data: { ...configuration }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) this.refresh();
        });
    }

    private refresh(): void {
        this.configurationService.getAll().subscribe({
            next: result => {
                this.list = result;
                this.dataSource.data = result;
            },
            error: () => { }
        });
    }
}